import { Tooltip } from '@mui/material';
import { theme as muiTheme } from './muiTheme';

// note, if the child props are not mui components, they will need the props and ref to be passed down, see https://mui.com/material-ui/react-tooltip/#custom-child-element
export default function InnoTooltip({ children, title, placement, color, sxStyle }) {
    return (
        <Tooltip 
            title={title} 
            placement={placement}
            arrow
            slotProps={{ popper: { sx: {
                "& .MuiTooltip-arrow": {
                    color: color||muiTheme.palette.secondary.main
                },
                "& .MuiTooltip-tooltip": {
                    backgroundColor: color||muiTheme.palette.secondary.main
                },
                ...sxStyle
            }}
            }}
        >
            {/* the purpose of the span is to enable the tooltip when a button child is disabled, see https://mui.com/material-ui/react-tooltip/#disabled-elements */}
            <span>
                {children}
            </span>
        </Tooltip>
    );
}